// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2hC2b","name":"ConsentHeader_name__3Ao1o","birthday":"ConsentHeader_birthday__22BB3","skeleton":"ConsentHeader_skeleton__2IX6P"};